<template>
  <div>
      <van-nav-bar title="领取奖励记录" left-text="" left-arrow @click-left="onClickLeft()" />
      <van-tabs>
        <van-tab title="任务奖励">
          <div class="table_detail" style="margin-top:10px;">
            <table>
              <thead>
                <tr>
                  <th style="width:80px;">序号</th>
                  <th style="width:80px;">奖励积分</th>
                  <th>其他奖励</th>
                  <th>是否核销</th>
                  <th>领取时间</th>
                  <th style="width:180px;">备注</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,idx) in reward1List" v-bind:key="idx">
                  <td style="width:80px;">{{ idx+1 }}</td>
                  <td style="width:80px;">{{ item.RewardAmount+'' }}</td>
                  <td>{{ item.OtherReward+'' }}</td>
                  <td>{{ item.IsGrant==0?'否':'是' }}</td>
                  <td>{{ item._CreateTime+'' }}</td>
                  <td style="width:180px;text-align:left;">{{ item.Remark }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <van-pagination
            mode="simple"
            v-model="currentPage"            
            :page-count="pageCount"
            :show-page-size="3"
            force-ellipses
            style="margin-top:20px;" @change="handleCurrentChange" />
        </van-tab>
        <van-tab title="累积带单奖励">
          <div class="table_detail" style="margin-top:10px;">
            <table>
              <thead>
                <tr>
                  <th style="width:80px;">序号</th>
                  <th style="width:80px;">奖励积分</th>
                  <th>领取时间</th>
                  <th style="width:180px;">备注</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item2,idx) in reward2List" v-bind:key="idx">
                  <td style="width:80px;">{{ idx+1 }}</td>
                  <td style="width:80px;">{{ item2.CurrentReward }}</td>
                  <td>{{ item2._CreateTime+'' }}</td>
                  <td style="width:180px;text-align:left;">{{ item2.Remark }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <van-pagination
            mode="simple"
            v-model="current2Page"            
            :page-count="pageCount2"
            :show-page-size="3"
            force-ellipses
            style="margin-top:20px;" @change="handleCurrent2Change" />
        </van-tab>
      </van-tabs>

    </div>    
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, NavBar, Grid, GridItem, Tabs, Tab } from "vant";
import { Button, Field } from "vant";
import { Divider } from "vant";
import { Popup } from "vant";
import { CountDown } from 'vant';
import { Pagination } from 'vant';

export default {
  name: "IntegrallogList",
  data() {
    return {      
      currentPage: 1,
      reward1List: [],
      loading: false, // 是否处在加载状态
      finished: false,// 是否已加载完成
      total: 0,				// 数据总条数
      pageCount: 0,   // 总页数
      pageSize: 0,    // 每页条数
      current2Page: 1,
      reward2List: [],
      loading2: false, // 是否处在加载状态
      finished2: false,// 是否已加载完成
      total2: 0,				// 数据总条数
      pageCount2: 0,   // 总页数
      pageSize2: 0,    // 每页条数
    };
  },
  props: {},
  computed:{
  },
  methods: {
    GetReward1Data(){
      var that=this;
      that.$http.get("Activity/GetSDWorkerRewardList", {
              params: {
                period:1,
                pageindex: that.currentPage,
                sort: '_CreateTime DESC',
              }
            }).then(res=>{
              that.reward1List=res.data.ListData;
              that.total = res.data.TotalCount;		// 给数据条数赋值
              that.loading = true;			// 加载状态结束 
              that.pageCount = res.data.PageCount;
              that.pageSize = res.data.PageSize;
              // 如果list长度大于等于总数据条数,数据全部加载完成
              if (that.reward1List.length >= res.data.TotalCount) {
                  that.finished = true;		// 结束加载状态
              }
        });
    },
    GetReward2Data(){
      var that=this;
      that.$http.get("Activity/GetAccrueRewardList", {
              params: {
                period:1,
                pageindex: that.current2Page,
                sort: '_CreateTime DESC',
              }
            }).then(res=>{
              that.reward2List=res.data.ListData;
              that.total2 = res.data.TotalCount;		// 给数据条数赋值
              that.loading2 = true;			// 加载状态结束 
              that.pageCount2 = res.data.PageCount;
              that.pageSize2 = res.data.PageSize;
              // 如果list长度大于等于总数据条数,数据全部加载完成
              if (that.reward2List.length >= res.data.TotalCount) {
                  that.finished2 = true;		// 结束加载状态
              }
        });
    },
    handleCurrentChange (page) {
      this.currentPage = page;      
      this.GetReward1Data();
    },
    handleCurrent2Change (page) {
      this.current2Page = page;      
      this.GetReward2Data();
    },
    /*返回 */
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  mounted(){
    this.GetReward1Data();
    this.GetReward2Data();
  },
  created() {
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [CountDown.name]:CountDown,
    [Pagination.name]:Pagination,
    [NavBar.name]:NavBar,
    [Grid.name]:Grid,
    [GridItem.name]:GridItem,
    [Tabs.name]:Tabs,
    [Tab.name]:Tab
  },
};
</script>


<style scoped>
  
    body {
        margin: 0;
        padding: 0;
    }

    .scroll-table-demo {
        height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .scroll-table-title {
        height: 80px;
        line-height: 24px;
        font-weight: bold;
        background-color: #7fd75a;
        color: #fff;
        display: flex;
        align-items: center;
        padding-left: 20px;
    }

    /* 全局css配置 */
    .scroll-table {
        height: calc(100% - 80px);
    }

    .scroll-table table {
        border: none;
        border-collapse: collapse;

    }

    .scroll-table td,
    .scroll-table th {
        padding: 0;
    }

    .scroll-table-container {
        display: flex;
        height: 100%;
        overflow: hidden;
    }

    .scroll-table-left,
    .scroll-table-slider {
        display: flex;
        flex-direction: column;
        box-shadow: 1px 3px 5px #eee;
    }


    .scroll-table-left-top,
    .scroll-table-slider-top {
        height: 45px;
        background-color: #f5f7fa;
        position: relative;
        z-index: 10;
    }

    .scroll-table-right-top {
        background-color: #f5f7fa;
    }

    .scroll-table-left-top div,
    .scroll-table-slider div {
        width: 60px;
        height: 45px;
        line-height: 45px;
        text-align: center;
    }

    .scroll-table-left-top tr,
    .scroll-table-slider-top tr {
        border-bottom: 1px solid #ebeef5;
    }

    .scroll-table-left-freeze,
    .scroll-table-slider-freeze {
        flex: 1;
        height: calc(100% - 45px - 45px);
    }

    .scroll-table-left-freeze tr,
    .scroll-table-slider-freeze tr {
        border-bottom: 1px solid #ebeef5;
        box-sizing: border-box;
    }

    .scroll-table-left-freeze td>div,
    .scroll-table-slider-freeze td>div {
        width: 60px;
        height: 45px;
        line-height: 45px;
        text-align: center;
    }

    .scroll-table-left-bottom,
    .scroll-table-slider-bottom {
        height: 45px;
        background-color: #f5f7fa;
        position: relative;
        z-index: 10;
    }

    .scroll-table-left-bottom tr,
    .scroll-table-slider-bottom .tr {
        margin: 0;
        padding: 0;
    }

    .scroll-table-left-bottom th>div,
    .scroll-table-slider-bottom th>div {
        width: 60px;
    }

    .scroll-table-right {
        overflow: hidden;
        flex: 1;
        display: flex;
        flex-direction: column;
        font-size: 13px;
    }

    .scroll-table-right-bottom {
        background-color: #1890ff;
        color: #fff;
    }

    .scroll-table-right-bottom td>div {
        width: 90px;
        height: 45px;
        line-height: 45px;
        text-align: center;
    }

    .scroll-table-right-top tr {
        border-bottom: 1px solid #ebeef5;
        background-color: #f5f7fa;
    }

    .scroll-table-right-top th>div {
        width: 90px;
        height: 45px;
        line-height: 45px;
        text-align: center;
    }

    .scroll-table-right-content {
        flex: 1;
        overflow: hidden;
    }

    .scroll-table-right-content tr {
        border-bottom: 1px solid #ebeef5;
    }

    .scroll-table-right-content td>div {
        width: 90px;
        height: 45px;
        line-height: 45px;
        text-align: center;
    }
    .van-grid-item {
        height: 45px;
    }

    /* 样式 */
    .table_detail{
      overflow:auto;
      width: 100%;
      /* 固定滚动高度 */
      max-height: calc(100vh - 220px);
      border-top: 1px solid #EBEBEB;
      border-bottom: 1px solid #EBEBEB;
      border-right: 0;
      
    }
    table {
      border-collapse: collapse;
      table-layout: fixed;
      width: 100%;
    }
    td, th {
      border-right: 1px solid #EBEBEB;
      border-bottom :1px solid #EBEBEB;
      width:100px;
      height: 35px;
      color: #333;
      box-sizing: border-box;
      background-color: #ffffff;
      font-size: 12px;
      text-align: center;
      padding: 5px 5px 5px 0;
    }
    th {
      background: #FAFAFA;
      color: #999;
      font-weight: normal;
    }
    /* 固定首列*/
    td:first-child,
    th:first-child {
      width:100px;
      position:sticky;
      left:0;
      z-index:1;
      padding-left: 5px;
    }
    /* 固定表头*/
    thead tr th {
      position:sticky;
      top:0;
    }
    th:first-child{
      z-index:2;
    }
    /* 固定表头*/
    tfoot tr th {
      position:sticky;
      bottom:0;
      color: #333;
      font-weight: bold;
      border-bottom: 0;
    }
    th:first-child{
      z-index:2;
    }

</style>
